import React, { PropsWithChildren } from "react";
import { LaunchDarklyProvider } from "./LaunchDarklyContext";
import { DatadogRumProvider } from "./DatadogRumContext";
import { UploadProvider } from "./UploadContext";
import { EntityUploadSessionsProvider } from "./EntityUploadSessionsContext";
import { ViewsSnapshotUploadProvider } from "./ViewsSnapshotUploadContext";
import { ViewsPendingCapturesProvider } from "./ViewsPendingCapturesContext";

export default function GlobalProviders(p: PropsWithChildren<{}>) {
  return (
    <LaunchDarklyProvider>
      <DatadogRumProvider>
        <UploadProvider>
          <EntityUploadSessionsProvider>
            <ViewsSnapshotUploadProvider>
              <ViewsPendingCapturesProvider>
                {p.children}
              </ViewsPendingCapturesProvider>
            </ViewsSnapshotUploadProvider>
          </EntityUploadSessionsProvider>
        </UploadProvider>
      </DatadogRumProvider>
    </LaunchDarklyProvider>
  );
}
